import { render, staticRenderFns } from "./DocHeader.vue?vue&type=template&id=6f92e527&"
import script from "./DocHeader.vue?vue&type=script&lang=js&"
export * from "./DocHeader.vue?vue&type=script&lang=js&"
import style0 from "./DocHeader.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports